// extracted by mini-css-extract-plugin
module.exports = {"container":"Gallery_container__1HQYo","controls":"Gallery_controls__3e5Aw","image":"Gallery_image__31_Mi","button":"Gallery_button__FdOpM"};